import styled from "styled-components";
import { responsiveWidth } from "responsive";

interface CollapseWrapperProps {
  isExpanded: boolean;
}

export const Wrapper = styled.div`
  background-color: #fbfbfb;
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: left;
  width: 100%;

  &.footer-none {
    display: none;
  }
`;

export const Container = styled.div`
  ${responsiveWidth}
  width: 100%;
  margin: 0 auto;
  align-items: center;

  .title {
    grid-column: span 2;
    font-family: NanumSquareOTF;
    font-size: 20px;
    font-weight: 700;
    line-height: 1.3;
    padding: 20px 0 10px;
    cursor: pointer;
  }

  .step {
    padding-bottom: 30px;
  }
`;

export const Box = styled.div`
  display: flex;
  flex-direction: row;
  gap: 9px;

  .item {
    display: flex;
    flex-direction;
    gap: 5px;
     font-family: NanumSquareOTF;
    font-size: 12px;
    line-height: 1.3;
    letter-spacing: -0.05em;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    white-space: nowrap;

    .key {
      font-weight: 700;
    }

    .value {
      font-weight: 400;
    }
  }
`;

export const SubBox = styled.div`
  .title {
    font-family: NanumSquareOTF;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.3;
    letter-spacing: -0.05em;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  }

  .item {
    display: flex;
    flex-wrap: wrap;
    gap: 9px;

    .key {
      font-family: NanumSquareOTF;
      font-size: 12px;
      font-weight: 700;
      line-height: 1.3;
      letter-spacing: -0.05em;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
    }

    .value {
      font-family: NanumSquareOTF;
      font-size: 12px;
      font-weight: 400;
      line-height: 1.3;
      letter-spacing: -0.05em;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
    }
  }
`;

export const Title = styled.div`
  font-family: NanumSquareOTF;
  font-size: 19px;
  font-weight: 700;
  line-height: 9px;
  letter-spacing: -0.05em;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;

export const TextMin = styled.div`
  font-family: NanumSquareOTF;
  font-weight: 400;
  line-height: 1.3;
  letter-spacing: -0.05em;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;

export const ContainerTerm = styled.div`
  background: #c7c7c7;

  .wrapper {
    ${responsiveWidth}
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 15px 0px;

    .container-term-list {
      display: flex;
      flex-direction: column;

      .item {
        display: flex;
        flex-direction: row;
        gap: 9px 18px;

        .term {
          display: flex;
          flex-direction: row;
          gap: 9px 18px;
          cursor: pointer;
        }
      }
    }

    .sns {
      cursor: pointer;
      display: flex;
      flex-direction: row;
      gap: 13px;
    }
  }

  .mobile-wrapper {
    ${responsiveWidth}
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 28px 0px;

    .container-term-list {
      display: flex;
      flex-direction: column;

      .item {
        display: flex;
        flex-direction: row;
        gap: 9px 18px;

        .term {
          display: flex;
          flex-direction: row;
          gap: 9px 18px;
          cursor: pointer;
        }
      }
    }

    .sns {
      cursor: pointer;
      display: flex;
      flex-direction: row;
      gap: 15px;

      img {
        width: 35px;
        height: 35px;
      }
    }
  }
`;

export const ExpandButton = styled.button`
  background: #fbfbfb;
`;

export const CollapseWrapper = styled.div<CollapseWrapperProps>`
  max-height: ${(props) => (props.isExpanded ? "300px" : "0px")};
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5px;
`;